// @flow
import {getPlaceIdApi} from '../../api';
import {MapAutocompleteServices} from '../MapServices';

import type {SuggestedAddress} from '../MapServices';

export class GoogleMapsAutocompleteServices implements MapAutocompleteServices {
  autoCompleteService: ?any;
  sessionToken: ?any;

  constructor(provider: any) {
    this.sessionToken = new provider.maps.places.AutocompleteSessionToken();
    this.autoCompleteService = new provider.maps.places.AutocompleteService();
  }

  getPlaceSuggestions = (input: string): Promise<any> => {
    if (this.autoCompleteService) {
      return this.autoCompleteService.getPlacePredictions({
        input: input,
        sessionToken: this.sessionToken ? this.sessionToken : undefined,
      });
    }
    return new Promise(function(resolve, reject) {
      resolve(null);
    });
  };

  getPlaceId = (placeId: string): Promise<any> => {
    return getPlaceIdApi({
      provider: 'GOOGLE_MAPS',
      place_id: placeId,
      session_token: this.sessionToken ? this.sessionToken.Fm : '',
    }).toPromise();
  };

  formatPredictions = ({
    items,
  }: {
    items: any[],
  }): {predictions: SuggestedAddress[]} => {
    const predictions: SuggestedAddress[] = items.map(city => ({
      ...city,
      description: city.title,
      placeId: city.id,
    }));
    return {predictions};
  };

  formatLocation = (location: {[key: string]: string}) => {
    console.log('formatLocation IS NOT IMPLEMENTED');
    return null;
  };
}
